<template>
  <div class="psFundsDetail">
    <div class="select">
      <el-form ref="form" label-position="right">
        <el-form-item>
          <el-date-picker v-model="time" type="daterange" popper-class="date-style" :append-to-body="false" range-separator="至"
            start-placeholder="开始日期" end-placeholder="结束日期" format="yyyy 年 MM 月 dd 日" value-format="yyyy-MM-dd">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button style="background-color:#A9F5F2;margin: 0" icon="el-icon-search" @click="getAllFundsDetail">搜索</el-button>
          <el-button style="background-color:#A9F5A9" icon="el-icon-refresh" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="data">
      <el-table :data="response"  v-loading="loading" element-loading-text="数据加载中" element-loading-spinner="el-icon-loading"
                style="margin:auto;width:calc(100% - 30px)" height="740" border :header-cell-style="{background:'#01DFD7',color:'#fff'}" element-loading-background="rgba(0.8, 0, 0, 0.3)">
        <el-table-column label="订单来源" align="center" prop="type"></el-table-column>
        <el-table-column label="普通订单收益" align="center" prop="payOrder"></el-table-column>
        <el-table-column label="普通订单退款" align="center" prop="refundOrder"></el-table-column>
        <el-table-column label="购买订单收益" align="center" prop="buyOrder"></el-table-column>
        <el-table-column label="购买订单退款" align="center" prop="backOrder"></el-table-column>
        <el-table-column label="余额支付收益" align="center" prop="pbAvailableOrder"></el-table-column>
        <el-table-column label="余额支付收益退款" align="center" prop="rbAvailableOrder"></el-table-column>
        <el-table-column label="充值余额" align="center" prop="chargeAvailable"></el-table-column>
        <el-table-column label="退余额" align="center" prop="dischargeAvailable"></el-table-column>
        <el-table-column label="退余额手续费" align="center" prop="dischargeRateMoney"></el-table-column>
        <el-table-column label="充值会员" align="center" prop="rechargVip"></el-table-column>
        <el-table-column label="充值优惠券" align="center" prop="chargeCoupon"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import {getAllPcCapitalDetail} from '../../../api/accountFunds/psfundsdetail'
export default {
  name: 'PsFundsDetail',
  data () {
    return {
      response: [],
      time: '',
      loading: false
    }
  },
  methods: {
    getAllFundsDetail(){
      getAllPcCapitalDetail({startTime: this.time[0],endTime:this.time[1]}).then(result => {
        this.response = result.data;
      })
    },
    reset(){
      this.time = ''
      this.getAllFundsDetail();
    }
  },
  created() {
    this.getAllFundsDetail()
  }
}
</script>

<style scoped>
.psFundsDetail {
  width: 100%;
  height: 100%;
}
.el-form {
  float: left;
}
.el-form-item {
    display: inline-block !important;
  }
</style>



// WEBPACK FOOTER //
// src/pages/finance/fundsaccount/psfundsdetail.vue